import React, { useContext } from "react";
import { UploadContext } from "../../context/UploadContext";

const UploadProgressModal = () => {
    const { uploadProgress } = useContext(UploadContext);

    if (!uploadProgress.visible) return null;

    const isSuccess = uploadProgress?.status === "success";

    return (
        <div className="upload-widget">
            {!isSuccess ? (
                <>
                    <div className="upload-widget__header">
                        <h4>Uploading Images</h4>
                        <span>{uploadProgress?.percentage}%</span>
                    </div>

                    <p className="upload-widget__message">
                        {uploadProgress?.uploaded} of {uploadProgress?.total} uploaded
                    </p>

                    <div className="upload-widget__progress">
                        <div
                            className="fill"
                            style={{
                                width: `${uploadProgress?.percentage}%`,
                            }}
                        />
                    </div>

                    <p className="upload-widget__footer">
                        {uploadProgress?.message}
                    </p>
                </>
            ) : (
                <>
                    <div className="upload-widget__success">
                        <div className="icon">
                            <img height={30} width={30} src="/assets/images/checkmark-fill-green.svg" />
                        </div>
                        <div>
                            <h4>Upload Complete</h4>
                            <p>{uploadProgress?.message}</p>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default UploadProgressModal;